/* eslint-disable */

const awsConfig = {
    //  AWS IoT Core region (Default value from DB, can be selected by user)
    "aws_project_region": "ap-east-1",
    //  Account specific, fixed at account creation
    "aws_cognito_identity_pool_id": "ap-southeast-1:8068b052-179b-450f-ae47-05cd7d78e4d1",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_BaLhvrrxa",
    "aws_user_pools_web_client_id": "pb8e9k8prb2g07ek6uv6l9k7g",
    "oauth": {},
};

export default awsConfig;
